export const SAGA_CREATE_GEOFENCE = 'SAGA_CREATE_GEOFENCE';
export const SAGA_GET_GEOFENCE = 'SAGA_GET_GEOFENCE';

export const SET_GEOFENCE = 'SET_GEOFENCE';


// WEBPACK FOOTER //
// ./src/Geofence/actions.js